import React, { useContext } from "react";
import { Box, Typography } from "@material-ui/core";
import Text from "../../../../shared/components/Text";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { useTheme } from "@material-ui/styles";
import { capitalizeEachWord } from "nemuru-components";
import { AssetType } from "@nemuru-eng/js-api-client";

export default function Slide1({ isScreenXs, loan, onBoardingByBorrower }) {
  const {
    state: { merchant },
  } = useContext(ProcessContext);
  const { palette } = useTheme();

  return (
    <Box mt={3} mx={2} className={"appear-anim"}>
      <Box display="flex" justifyContent="center" mb={2}>
        <Typography
          align="center"
          variant={isScreenXs ? "h5" : "h4"}
          style={{
            color: palette.text.title,
          }}
        >
          <strong>
            <Text tId="HI" />
          </strong>
        </Typography>
      </Box>
      <Typography
        align="center"
        variant={"subtitle1"}
        style={{
          color: palette.text.title,
          lineHeight: "1.4",
          marginTop: "0.25rem",
        }}
      >
        <strong>
          {onBoardingByBorrower ? (
            merchant?.registration_fields?.business_name ? (
              <Text
                tId={
                  loan.asset_reference[0].type === AssetType.CARD
                    ? "INVITATION_MSG_CARD"
                    : "INVITATION_MSG"
                }
                dynamicDataTexts={[
                  merchant?.registration_fields?.business_name,
                ]}
              />
            ) : (
              <Text tId="NEUTRAL_INVITATION_MSG" />
            )
          ) : (
            <Text
              tId={"INVITATION_MSG"}
              dynamicDataTexts={[
                capitalizeEachWord(
                  loan.borrower_invitation.full_name.first_name
                ),
              ]}
            />
          )}
        </strong>
      </Typography>
      <Box mt={4}>
        <Typography
          align="center"
          variant={"body2"}
          style={{ color: palette.text.primaryy }}
        >
          <Text tId="PAPERLESS_EASY_AND_FAST" />
        </Typography>
      </Box>
    </Box>
  );
}
